module.exports = __webpack_public_path__ + "static/media/photo-6.5344a466.jpg";